import StationLandingPage from "./Pages/HomePage/StationLandingPage";
import SkillStorePage from "./Pages/HomePage/skillStorePage";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <div className="h-screen w-full min-w-0 overflow-x-hidden">
        <Routes>
          <Route path="/" element={<StationLandingPage />} />
          <Route path="/skillStore" element={<SkillStorePage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;

